import React from "react"
import { ClockCircleOutlined, UserOutlined } from "@ant-design/icons"
import moment from "moment"
import { twMerge } from "tailwind-merge"

const ShiftTile: React.FC<{
	employeeName: string
	postName: string
	startTime: string
	finishTime: string
	color: string
}> = ({ employeeName, postName, startTime, finishTime, color }) => (
	<div className="relative flex w-full items-center bg-white py-4 px-6">
		{/* Left Color Indicator */}
		<div className={twMerge("mr-4 w-[3px] flex-shrink-0 self-stretch rounded-full", color)}></div>

		<div className="flex w-full flex-col gap-2.5">
			<div className="flex items-center">
				<UserOutlined className="mr-3 text-[15px] text-gray-500" />
				<span className="text-sm font-medium text-gray-900">{employeeName}</span>

				<span className="ml-3 rounded bg-blue-50 px-2 py-0.5 text-xs font-medium text-[#3b82f6]">
					{postName}
				</span>
			</div>
			<div className="flex items-center text-sm text-gray-500">
				<ClockCircleOutlined className="mr-3 text-[15px] text-gray-500" />
				<span>
					{moment(startTime).format("HH:mm")} - {moment(finishTime).format("HH:mm")}
				</span>
			</div>
		</div>
	</div>
)

export default ShiftTile
